(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gfm-video-hero-premium"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const hero = document.querySelector('[data-gfm-video-hero="{{ section.id }}"]');
    const line = document.getElementById('gfm-vline-{{ section.id }}');
    if(!hero || !line) return;

    let ticking = false;

    const getHeaderH = () => {
      const v = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
      const n = parseFloat(v || '0');
      return Number.isFinite(n) ? n : 0;
    };

    const update = () => {
      ticking = false;

      const headerH = getHeaderH();
      line.style.top = headerH + 'px';

      const r = hero.getBoundingClientRect();

      /* "In view" while any part of hero exists below header and above bottom */
      const inView = (r.bottom > headerH + 2) && (r.top < window.innerHeight);

      if(inView) line.classList.add('is-on');
      else line.classList.remove('is-on');
    };

    const onScroll = () => {
      if(ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    /* initial */
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      /* Topbar smooth behavior (hysteresis / no 1-tick flip) */
      this.topbarHidden = false;
      this.topbarLastToggle = 0;

      // Tunables
      this.TOPBAR_HIDE_AT = 12;      // stay visible right at the top
      this.TOPBAR_HIDE_ACCUM = 28;   // must scroll DOWN this much before hiding
      this.TOPBAR_SHOW_ACCUM = 18;   // must scroll UP this much before showing
      this.TOPBAR_COOLDOWN = 160;    // ms

      this._tbAccum = 0;             // accumulate movement in one direction
      this._tbDir = 0;               // 1 down, -1 up

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      /* Ensure correct state on load */
      requestAnimationFrame(() => {
        const st = window.pageYOffset || document.documentElement.scrollTop || 0;
        const sectionEl = this.closest('.shopify-section');
        if (!sectionEl) return;

        if (st > this.TOPBAR_HIDE_AT) {
          sectionEl.classList.add('gfm-topbar-hidden');
          this.topbarHidden = true;
        } else {
          sectionEl.classList.remove('gfm-topbar-hidden');
          this.topbarHidden = false;
        }
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    setTopbarHidden(shouldHide) {
      const sectionEl = this.closest('.shopify-section');
      if (!sectionEl) return;

      const now = Date.now();
      if (now - this.topbarLastToggle < this.TOPBAR_COOLDOWN) return;

      if (shouldHide && !this.topbarHidden) {
        sectionEl.classList.add('gfm-topbar-hidden');
        this.topbarHidden = true;
        this.topbarLastToggle = now;
      } else if (!shouldHide && this.topbarHidden) {
        sectionEl.classList.remove('gfm-topbar-hidden');
        this.topbarHidden = false;
        this.topbarLastToggle = now;
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const scrollingDown = scrollTop > this.currentScrollTop;
      const delta = Math.abs(scrollTop - this.currentScrollTop);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      /* TOPBAR hide/show (SMOOTH HYSTERESIS) */
      if (scrollTop <= this.TOPBAR_HIDE_AT) {
        this._tbAccum = 0;
        this._tbDir = 0;
        this.setTopbarHidden(false);
      } else {
        const dir = scrollingDown ? 1 : -1;

        if (dir !== this._tbDir) {
          this._tbDir = dir;
          this._tbAccum = 0;
        }

        if (delta > 0) this._tbAccum += delta;

        if (!this.topbarHidden) {
          if (this._tbDir === 1 && this._tbAccum >= this.TOPBAR_HIDE_ACCUM) {
            this.setTopbarHidden(true);
            this._tbAccum = 0;
          }
        } else {
          if (this._tbDir === -1 && this._tbAccum >= this.TOPBAR_SHOW_ACCUM) {
            this.setTopbarHidden(false);
            this._tbAccum = 0;
          }
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ===== GFM: clicking the top-level text navigates (does not toggle dropdown) ===== */
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('header-menu summary.header__menu-item .gfm-toplink') : null;
    if(!a) return;

    // stop the <summary> toggle from triggering
    e.preventDefault();
    e.stopPropagation();

    // navigate clean
    window.location.href = a.href;
  }, true);

  } catch(e) { console.error(e); }
})();
})();
